/* Wisepops TRACKER   */

export const track = (eventType, eventName, data) => {
  if (eventType === "pv") {
    window.wisepops && window.wisepops("pageview")
  }
};
